import moment from 'moment'
import {Ventrata} from 'types'

export const getProductDurationFrom = (product: Ventrata.Product) => {
  let savedDuration = ''
  let savedMomentDuration: moment.Duration | null = null

  for (const option of product.options) {
    if (!option.durationAmount || !option.durationUnit) {
      continue
    }

    const duration = moment.duration(
      option.durationAmount,
      option.durationUnit as moment.unitOfTime.DurationConstructor
    )

    if (!savedMomentDuration || duration.toISOString() > savedMomentDuration.toISOString()) {
      savedMomentDuration = duration
      savedDuration = option.duration || ''
    }
  }

  return savedDuration || '-'
}
